import * as actionTypes from "./actionTypes";
import * as actionUrl from "../../config/actionUrl";
import axios from "axios";

export const resetGenerateIdStore = () => {
  return {
    type: actionTypes.RESET_GENERATE_ID_STORE,
  };
};

export const generateProductIdDownloadFail = (error) => {
  return {
    type: actionTypes.GENERATE_ID_DOWNLOAD_FAIL,
    error: error.debugMessage,
  };
};

export const generateProductIdDownloadSuccess = (result) => {
  return {
    type: actionTypes.GENERATE_ID_DOWNLOAD_SUCCESS,
    result: result,
  };
};

export const generateProductIdDownloadStart = () => {
  return {
    type: actionTypes.GENERATE_ID_DOWNLOAD_START,
  };
};

export const generateProductIdDownload = (formData) => {
  return async (dispatch) => {
    axios
      .post(actionUrl.VALIDATE_REQUEST_URL, formData, { mode: "cors", withCredentials: true })
      .then((resp) => {
        //Input are validated successully
        if (resp.status === 200 && resp.data === "No Error Found") {
          dispatch(generateProductIdDownloadStart());
          axios
            .post(actionUrl.GENERATE_DOWNLOAD_URL, formData, {
              headers: {
                "Content-Type": "application/json",
              },
              mode: "cors",
              withCredentials: true,
            })
            .then((res) => {
              dispatch(generateProductIdDownloadSuccess(res.data));
            })
            .catch((err) => {
              console.log(err);
              dispatch(
                generateProductIdDownloadFail({
                  debugMessage: "An error occured",
                })
              );
            });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          generateProductIdDownloadFail(err.response.data.producterrorresponse)
        );
      });
  };
};

export const generateProductIdEmailFail = (error) => {
  return {
    type: actionTypes.GENERATE_ID_EMAIL_FAIL,
    error: error.debugMessage,
  };
};

export const generateProductIdEmailSuccess = (result) => {
  return {
    type: actionTypes.GENERATE_ID_EMAIL_SUCCESS,
    result: result,
  };
};

export const generateProductIdEmailStart = () => {
  return {
    type: actionTypes.GENERATE_ID_EMAIL_START,
  };
};

export const generateProductIdEmail = (formData) => {
  return async (dispatch) => {
    dispatch(generateProductIdEmailStart());
    axios
      .post(actionUrl.GENERATE_EMAIL_URL, formData, {
        headers: {
          "Content-Type": "application/json",
        },
        mode: "cors",
        withCredentials: true,
      })
      .then((resp) => {
        dispatch(generateProductIdEmailSuccess(resp.data));
      })
      .catch((err) => {
        dispatch(
          generateProductIdEmailFail(err.response.data.producterrorresponse)
        );
      });
  };
};
